import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';
import { ThemingService } from '../services/theming.service';

@Directive({
    selector: '[keyboardFocusTooltip]'
})
export class KeyboardFocusTooltipDirective implements AfterViewInit {
    private toolTipSpan = null;
    private toolTipDelayTimeout;

    constructor(
        public elementReference: ElementRef,
        public renderer: Renderer2,
        public themingService: ThemingService
    ) {}

    public ngAfterViewInit() {
        this.elementReference.nativeElement.onfocus = () => {
            if (this.elementReference.nativeElement.title) {
                this.onEvent();
            }
        };

        this.elementReference.nativeElement.onblur = () => {
            if (this.toolTipSpan) {
                this.renderer.removeChild(this.elementReference.nativeElement, this.toolTipSpan);
            }

            if (this.toolTipDelayTimeout) {
                clearTimeout(this.toolTipDelayTimeout);
                this.toolTipDelayTimeout = null;
            }
        };
    }

    private onEvent() {
        this.toolTipDelay().then(() => {
            this.toolTipSpan = document.createElement('span');
            this.toolTipSpan.classList.add('ohp-keyboardfocus-tooltip');
            this.toolTipSpan.classList.add('ohpAppTheme');
            this.toolTipSpan.classList.add('ms-fcl-nd');
            this.toolTipSpan.classList.add('ms-bgc-w');
            this.toolTipSpan.innerText = this.elementReference.nativeElement.title;
            this.renderer.appendChild(this.elementReference.nativeElement, this.toolTipSpan);
        });
    }

    private toolTipDelay(): Promise<any> {
        return new Promise(resolve => {
            this.toolTipDelayTimeout = setTimeout(() => {
                resolve();
            }, 1000);
        });
    }
}
